import * as PaymentActionTypes from '../../actiontypes/payment';
import * as FateActionCreators from '../fate';

import PaymentService from 'services/PaymentService';
import { IBraintreePurchaseFateRequest } from 'types/payment';

export { default as selectCurrency } from 'actions/payment/selectCurrency';

const paymentService = new PaymentService();

/** ----------------------------------------------------------------------------
 * Payment Dialog
 -----------------------------------------------------------------------------*/
export const openDialog = (paymentType: any) => ({
  type: PaymentActionTypes.OPEN_DIALOG,
  payload: { paymentType },
});

export const closeDialog = () => ({ type: PaymentActionTypes.CLOSE_DIALOG });

/** ----------------------------------------------------------------------------
 * SELECT PACKAGE
 -----------------------------------------------------------------------------*/

export const selectPackage = (packageId: number) => ({
  type: PaymentActionTypes.SELECT_PACKAGE,
  payload: { packageId },
});

/** ----------------------------------------------------------------------------
 * PURCHASE ( with braintree )
 -----------------------------------------------------------------------------*/
export const purchaseWithBraintree = (data: IBraintreePurchaseFateRequest) => (dispatch: Function) => {
  dispatch(purchaseWithBraintreeRequested());

  return paymentService.purchaseWithBraintree(data)
    .then(({ data }) => {
      if (data.isSuccess) {
        dispatch(purchaseWithBraintreeSuccess(data));
        dispatch(FateActionCreators.fetch());
        return;
      }
      return Promise.reject({ message: data.message });
    })
    .catch(err => {
      // Dispatch an error, then re-throw for the caller to handle
      dispatch(purchaseWithBraintreeFailure(err));
      throw err;
    });
};

export const purchaseWithBraintreeRequested = () => ({ type: PaymentActionTypes.PURCHASE_REQUESTED });

export const purchaseWithBraintreeSuccess = (data: { message?: string | undefined, isSuccess: boolean }) => ({
  type: PaymentActionTypes.PURCHASE_SUCCESS,
  payload: {
    isSuccess: data.isSuccess,
    message: data.message,
  },
});

export const purchaseWithBraintreeFailure = (error: any) => ({
  type: PaymentActionTypes.PURCHASE_FAILURE,
  payload: error.message,
  error: true,
  status: error.response && error.response.status,
});

export const togglePriceBreakdown = () => ({
  type: PaymentActionTypes.TOGGLE_PRICE_BREAKDOWN,
});

export const togglePaymentProvider = () => ({
  type: PaymentActionTypes.TOGGLE_PAYMENT_PROVIDER,
});
